// @ts-strict-ignore
import { context as adContext } from '@wikia/ad-engine';

export function getMagniteS2sContext(video = false): object {
	const midBoxAdConfigs = adContext.get('options.replaceOpenWebWithMidBoxAd')
		? {
				mid_boxad: {
					sizes: [[300, 250]],
				},
			}
		: {};

	const context = {
		enabled: false,
		accountId: 7450,
		slots: {
			top_leaderboard: {
				sizes: [
					[728, 90],
					[970, 250],
				],
			},
			top_boxad: {
				sizes: [
					[300, 250],
					[300, 600],
				],
			},
			...midBoxAdConfigs,
			incontent_leaderboard: {
				sizes: [[728, 90]],
			},
			incontent_boxad: {
				sizes: [
					[160, 600],
					[300, 600],
					[300, 250],
					[300, 1050],
				],
			},
			bottom_leaderboard: {
				sizes: [
					[728, 90],
					[970, 250],
				],
			},
			featured: {
				sizes: [[640, 480]],
			},
			fandom_dt_galleries: {
				sizes: [[728, 90]],
			},
		},
	};

	if (!video) {
		delete context.slots.featured;
	}

	return context;
}
